import produce from 'immer';
import * as Actions from 'src/actions/types';
import * as AccountActions from 'src/actions/accountActions';
import * as Entities from 'src/config/Entities';

const initialState = {
  navigation: {
    tab: 'details'
  },
  delegate: null,
  delegates: null,
  pageinfo: null,
  fetching: false,
  mode: Entities.EntityMode.view
};

const mydelegateReducer = (state = initialState, action) => {
  switch (action.type) {
    // NAVIGATION
    case Actions.ME_DELEGATE_NAVIGATION_SET: {
      const { navigation } = action.payload;
      return produce(state, draft => {
        const newNav = {
          ...state.navigation,
          ...navigation
        };
        draft.navigation = newNav;
      });
    }

    // LIST
    case Actions.ME_DELEGATE_LIST_REQUEST: {
      return produce(state, draft => {
        draft.fetching = true;
      });
    }
    case Actions.ME_DELEGATE_LIST_RECEIVE: {
      const { entities, pageinfo } = action.payload;
      return produce(state, draft => {
        draft.pageinfo = pageinfo;
        draft.delegates = entities;
        draft.fetching = false;
      });
    }

    // ENTITY
    case Actions.ME_DELEGATE_MODE: {
      const { mode } = action.payload;
      return produce(state, draft => {
        draft.mode = mode;
      });
    }
    case Actions.ME_DELEGATE_REQUEST: {
      return produce(state, draft => {
        draft.fetching = true;
      });
    }
    case Actions.ME_DELEGATE_RECEIVE:
    case Actions.ME_DELEGATE_UPDATE: {
      const { entity } = action.payload;
      return produce(state, draft => {
        draft.delegate = entity;
        draft.fetching = false;
      });
    }
    case Actions.ME_DELEGATE_FINISHED: {
      return produce(state, draft => {
        draft.fetching = false;
      });
    }

    //------------------------------
    // From Account
    //------------------------------

    case AccountActions.LOGIN_REQUEST:
    case AccountActions.LOGOUT: {
      return produce(state, draft => {
        // Ensure we clear current session
        draft.delegate = null;
        draft.delegates = null;
        draft.pageinfo = null;
        draft.fetching = false;
      });
    }

    default: {
      return state;
    }
  }
};

export default mydelegateReducer;
